import {getStorageItem, setStorageItem} from '../../../services/storageService';
import {sendMonitor} from '../../../utils/monitoring';
import {isDevEnv} from '../../../utils/platform';
import {
    ISRAEL_TAX_REGULATION_BLOCKED_BY_USER,
    ISRAEL_TAX_REGULATION_SHOWN_TODAY
} from '../constants/featureConsts';
import {blacklist, featureMap, featurePulseCount, featuresIDs} from '../constants/map';
import {featurePopoverRef} from '../FeaturePopover.root';
import {getPortlets} from '../../Homepage/api/index';
import {WWWDBTODOLIST} from '../../Homepage/constants';
import {addPortlet} from '../../Homepage/actions/dialogs';

const FEATURE_KEY = 'features';
const PULSE_COUNT_KEY = 'featuresPulseCount';

export async function getBlackList() {
    const rawBlacklist = await getStorageItem(FEATURE_KEY);
    const {features} = rawBlacklist;
    return features ? features.split(',') : [];
}
export function updateBlackList(value) {
    featureMap.delete(value);
    blacklist.push(value);
    const stringfyBlacklist = blacklist.join(',');
    setStorageItem(FEATURE_KEY, stringfyBlacklist);
}

export function clearStorage() {
    setStorageItem(FEATURE_KEY, '');
    setStorageItem(PULSE_COUNT_KEY, '');
}

export async function getPulseShownCountStorage() {
    const pulseCountStorage = await getStorageItem(PULSE_COUNT_KEY);
    const pulseCountObj = pulseCountStorage[PULSE_COUNT_KEY];
    return pulseCountObj ? JSON.parse(pulseCountObj) : {};
}
export function updatePulseShownCount(featureID: string) {
    const count = featurePulseCount[featureID];
    featurePulseCount[featureID] = !count ? 1 : count + 1;
    setStorageItem(PULSE_COUNT_KEY, JSON.stringify(featurePulseCount));
}

export function showReconFeature(formName: string, anchor) {
    let featureID = null;

    switch (formName) {
        case 'BANKRECON':
            featureID = featuresIDs.bankRecon;
            break;
        case 'ACCRECON':
            featureID = featuresIDs.accRecon;
            break;
        case 'FINVOICES':
            featureID = featuresIDs.exportInvoiceEOL;
            break;
        default:
            break;
    }

    if (featureID && featureID !== featuresIDs.exportInvoiceEOL) {
        featurePopoverRef?.current?.showFeaturePopover(featureID, anchor);
    }
}

export function showAnalyticsFeature(anchor) {
    // todo: AlexR - it looks like the fucntion is not used, should we remove it?
    featurePopoverRef?.current?.showFeaturePopover(featuresIDs.analytics, anchor);
}

export const isAutomation = (): boolean => {
    return window.location.search.includes('_automation');
};

export const shouldShowIsraelTaxRegulationFeature = (formName: string): boolean => {
    // returns true if the feature should be shown
    const isCloud = isDevEnv() || window.location.host.includes('priority-connect');
    const today = new Date(); // Get today's date
    const startDate = new Date('2024-12-16'); // Start date
    const endDate = new Date('2025-01-16'); // End date
    const isBetween = (isDevEnv() && today <= endDate) || (today >= startDate && today <= endDate);
    const isBlockedByUser = !!window.localStorage.getItem(ISRAEL_TAX_REGULATION_BLOCKED_BY_USER);
    const shouldShowToday = !document.cookie.includes(ISRAEL_TAX_REGULATION_SHOWN_TODAY);
    return (
        isCloud &&
        shouldShowToday &&
        isBetween &&
        !isBlockedByUser &&
        (formName === 'DINVOICES' ||
            formName === 'AINVOICES' ||
            formName === 'EINVOICES' ||
            formName === 'RINVOICES' ||
            formName === 'YINVOICES' ||
            formName === 'PINVOICES' ||
            formName === 'SINVOICES' ||
            formName === 'FNCTRANS' ||
            formName === 'TINVOICES')
    );
};

export const setIsraelTaxRegulationCookie = () => {
    const midnight = new Date();
    midnight.setHours(23, 59, 59, 999);
    const utcMidnight = new Date(midnight.getTime() - midnight.getTimezoneOffset() * 60000);
    const expires = utcMidnight.toUTCString();

    document.cookie = `${ISRAEL_TAX_REGULATION_SHOWN_TODAY}=true; expires=${expires}; path=/`;
};

export const setIsraelTaxRegulationLocalStorage = (isButtonClicked?) => {
    if (isButtonClicked) {
        window.localStorage.setItem(ISRAEL_TAX_REGULATION_BLOCKED_BY_USER, 'true');
        sendMonitor(ISRAEL_TAX_REGULATION_BLOCKED_BY_USER);
    }
};

export const addToDoListWidgetPortlet = async () => {
    const portlets = await getPortlets();
    const toDoListPortlet = portlets.find(portlet => portlet.ename === WWWDBTODOLIST);
    const {exec, title} = toDoListPortlet;
    await addPortlet(exec, title);
};
